import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { HistoryIcon } from "lucide-react";

export interface AgentChatHistoryButtonProps {
  onClick?: () => void;
  className?: string;
}

export function AgentChatHistoryButton({ onClick, className }: AgentChatHistoryButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("h-7 w-7 text-muted-foreground", className)}
      title="Chat history"
      onClick={onClick}
    >
      <HistoryIcon className="h-4 w-4" />
    </Button>
  );
}
